import './InputBox.css'
import  { useEffect } from 'react';
import TooltipButton from '../../tooltip/Popover';

 const Inputbox = (props) => {
  const {
    wordboundation,
    value,
    onChange,
    onClick,
    type,
    placeholder,
    readOnly,
    inputStyle,
    disabled,
    id,
    htmlFor,
    label,
    required,
    inline,
    labelStyle ={fontWeight:500,color:"black"},
    fieldName,
    isextra,
     leftContent,
  } = props;

  useEffect(() => {
    if (wordboundation) {
      const wordCounterId = `word${wordboundation.id}`;
      const el = document.getElementById(wordCounterId);
      console.log(el,"el")
      if (el && value) {
        el.innerHTML = `${value?.length}/${wordboundation.limit}`;
      }
    }
  }, [wordboundation,value]);

  const storeValueWithWordboundation = (limit, id, e) => {
    let newText = e.target.value;
    let words = newText.trim().split(/\s+/);

    if (wordboundation?.limit && words?.length > wordboundation.limit) {
      words = words.slice(0, wordboundation?.limit);
      newText = words.join(' ');
    }
    newText = capitalizeLogic(newText);
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: newText,
        name:htmlFor,
      },
    };

    onChange(syntheticEvent);
    console.log()
    const el = document.getElementById(id);
    if (el) {
      el.innerHTML = `${e.currentTarget.value.length}/${limit}`;
    }
  };
  const storechange=(e)=>{
      let newText = e.target.value;
    
     newText = capitalizeLogic(newText);
    const syntheticEvent = {
      ...e,
      target: {
       
        ...e.target,
        value: newText,
        name:htmlFor,
      },
    };

    onChange(syntheticEvent);
  }
const capitalizeLogic = (text) => {
  if (!text) return text;
  return text.charAt(0).toUpperCase() + text.slice(1);
};

  const commonInputProps = {
    name:htmlFor,
    type,
    placeholder,
    value,
    className: `${isextra ? "custominputextra mt-1": "custominputform"} form-control ` ,
    onChange: (e) =>
      wordboundation
        ? storeValueWithWordboundation(wordboundation.limit, `word${wordboundation.id}`, e)
        : onChange && storechange(e),
    onClick: (e) => onClick && onClick(e),
    readOnly,
    style: inputStyle,
    maxLength: wordboundation && wordboundation.limit,
    disabled,
    id,
  };
console.log(value,"value")
  return (
    <>
      {inline ? (
        <div className="InlineInput">
          <div className="InlineFirstBox">
            <div className="InlineLabel" id="inlineInputLabel" style={{marginBottom:"10px"}}>
              <label   htmlFor={htmlFor} className="col-form-label" style={labelStyle}>
                {label}
                {required && (
                  <span style={{ color: 'red', fontSize: '18px', fontWeight: '600', paddingLeft: '5px' }}>*</span>
                )}
              </label>
            </div>
            <div className="InlineInuputBox" id="inlineInputBox">
              <input className='form-control' {...commonInputProps} />
            </div>
          </div>
          <div className="InlineWordcounter">
            {wordboundation && (
              <span id={`word${wordboundation.id}`} className="WordCounter" style={{ fontSize: '14px', color: 'gray' }}>
                0/{wordboundation.limit}
              </span>
            )}
          </div>
        </div>
      ) : (
        <div className="form-group">
          <div className="d-flex justify-content-between ">
          <label htmlFor={htmlFor} style={labelStyle}>
  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <div style={{ display: 'flex', alignItems: 'center', lineHeight: '1', height: '100%',width:"100%" }}>
      <span style={{ display: 'flex', alignItems: 'center' }}>{label}</span>
      {required && (
        <span style={{ color: 'red', fontSize: '18px', paddingLeft: '5px' }}>*</span>
      )}
      {fieldName &&  <span style={{paddingLeft:"10px", display: 'flex', alignItems: 'center' }}>
        <TooltipButton fieldName={fieldName} />
      </span>}
    </div>
  </div>
</label>
            {wordboundation && (
              <span
                id={`word${wordboundation.id}`}
                className="WordCounter"
                style={{ fontSize: '14px', color: 'gray' }}
              >
                0/{wordboundation.limit}
              </span>
            )}
          </div>
          {leftContent ? (
  <div
    onClick={(e) => !disabled && onClick && onClick(e)}
    className={`${isextra ? "custominputextra mt-1" : "custominputform"} form-control`}
    style={{
      display: "flex",
      alignItems: "center",
      gap: "10px",
      height: "auto",
      minHeight: "45px",
      cursor: disabled ? "not-allowed" : "pointer",
      backgroundColor: disabled ? "#e9ecef" : "#fff",
      ...inputStyle,
    }}
  >
    <div>{leftContent}</div>

    <span
      style={{
        color: value ? "#000" : "#999",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
    >
      {value || placeholder}
    </span>
  </div>
) : (
  <input {...commonInputProps} />
)}
        </div>
      )}
    </>
  );
};

export default Inputbox